import * as React from 'react';
import FeaturedLinkCard from '../FeaturedLinkCard/FeaturedLinkCard';
import S from './NavigationMegaMenu.styles';
const FeaturedItem = (props) => {
    if (!props.item.text) {
        return null;
    }
    return (React.createElement(S.Item, null,
        React.createElement(FeaturedLinkCard, { ...props.item })));
};
const Item = (props) => {
    if (!props.item.text) {
        return null;
    }
    return (React.createElement(S.Item, null,
        React.createElement(S.Link, { href: props.item.url, target: props.item.target },
            React.createElement(S.LinkTitle, null, props.item.text))));
};
const NavigationMegaMenu = (props) => {
    return (React.createElement(S.Container, { "data-active": props.active },
        React.createElement(S.Inner, null,
            renderFeaturedLinks(),
            renderLinks())));
    function renderFeaturedLinks() {
        if (!props.featured?.length) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            props.featured.map((item) => (React.createElement(FeaturedItem, { key: item.id, item: item }))),
            React.createElement(S.Divider, null)));
    }
    function renderLinks() {
        if (!props.items) {
            return null;
        }
        return props.items.map((item) => React.createElement(Item, { key: item.id, item: item }));
    }
};
export default NavigationMegaMenu;
